module.exports = __webpack_public_path__ + "static/media/oralift_user_status.c430717f.svg";